import { CoordinatorService } from "./coordinator.service"
import { Pin } from "./pin"
import { TableInstance } from "./table-instance"
import { TableRow } from "./table-row"
import { TAGTEMPL, TEMPL } from "./template-repository$"

export class Table {
    id: string
    rowLs: TableRow[] = []

    hideEmpty: boolean

    isGlobalEdit: boolean
    isLocalEdit: boolean
    pin: Pin | undefined

    constructor(private coords: CoordinatorService, params: TEMPL) {
        this.id = params.id || this.coords.uniqueId()
        this.isGlobalEdit = !!params.isGlobalEdit
        this.isLocalEdit = !!params.isLocalEdit
        this.hideEmpty = params.hideEmpty === true

        if (params.pinId) {
            this.pin = this.coords.pin$.getOrCreate({ id: params.pinId })
        }

        this.rowLs = params.tagLs.map(x => new TableRow(this.coords, this, x))

    }

    addRow(params: TAGTEMPL) {
        const tr = new TableRow(this.coords, this, params)
        this.rowLs.push(tr)
        return tr
        // params.withCell && tr.addCell({
        //     type: params.type || "string",
        //     tag: params.tag
        // })
    }

    instance(input: any) {
        return new TableInstance(this.coords, this, input)
    }
}


